import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Save, Send, Eye, History } from 'lucide-react';

interface PublishingHelpModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const Row: React.FC<{ icon: React.ReactNode; title: string; desc: string }> = ({
  icon,
  title,
  desc,
}) => (
  <div className="flex items-start gap-3">
    <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-muted text-foreground">
      {icon}
    </div>
    <div className="min-w-0">
      <p className="text-sm font-medium">{title}</p>
      <p className="text-sm text-muted-foreground">{desc}</p>
    </div>
  </div>
);

export const PublishingHelpModal: React.FC<PublishingHelpModalProps> = ({
  open,
  onOpenChange,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle>How publishing works</DialogTitle>
      </DialogHeader>

      <div className="space-y-4">
        <Row
          icon={<Save className="h-4 w-4" />}
          title="Save draft"
          desc="Saves your changes privately. Readers keep seeing the currently published version — nothing goes live yet."
        />
        <Row
          icon={<Send className="h-4 w-4" />}
          title="Publish"
          desc="Makes your latest draft the live version that readers see."
        />
        <Row
          icon={<Eye className="h-4 w-4" />}
          title="Visible"
          desc="Shows or hides this page in the help center. Turn it off to hide the page even when it's published."
        />
        <Row
          icon={<History className="h-4 w-4" />}
          title="Version history"
          desc="Every publish is saved. You can compare or restore previous versions anytime."
        />

        <p className="rounded-md bg-muted/50 p-3 text-xs text-muted-foreground">
          New articles stay hidden from readers until you publish them for the first time.
        </p>
      </div>
    </DialogContent>
  </Dialog>
);

export default PublishingHelpModal;
